import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import api from '../../config/axiosInstance';
import { setCredentials, setUser } from './../../config/authSlice';
import ROUTES from '../../routes';

function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(state => state.auth.accessToken);

    useEffect(() => {
        if (token) {
            navigate('/');
        }
    }, [token, navigate]);

    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState({ email: '', password: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSubmitting(true);
            const res = await api.post('auth/token', form);
            const token = res.headers['authorization'];
            dispatch(setCredentials(token));
            dispatch(setUser(res.data.user));
            navigate('/');
        } catch (err) {
            alert("Login failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="card-body bg-info">
            <div className="text-center mb-3">
                <a href="#/"><img className="logo-auth" style={{ 'width': '250px' }} src="/assets/logo.png" alt="" /></a>
            </div>
            <h4 className="text-center  text-white mb-4">Sign in your account</h4>
            <form onSubmit={handleSubmit}>
                <div className="form-group mb-4">
                    <label className="form-label text-white" htmlFor="email">Email</label>
                    <input
                        id="email"
                        type="text"
                        className="form-control"
                        placeholder="Enter email"
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />
                </div>
                <div className="form-group mb-3 mb-sm-4">
                    <label className="form-label text-white">Password</label>
                    <div className="position-relative">
                        <input
                            id="dz-password"
                            type="password"
                            className="form-control"
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                        />
                        <span className="show-pass eye">
                            <i className="fa fa-eye-slash"></i>
                            <i className="fa fa-eye"></i>
                        </span>
                    </div>
                </div>

                <div className="form-row d-flex flex-wrap justify-content-between align-items-baseline mb-2">
                    <div className="form-group mb-sm-4 mb-1">
                        <div className="form-check custom-checkbox ms-1">
                            <input type="checkbox" className="form-check-input" id="basic_checkbox_1" />
                            <label className="form-check-label text-white" htmlFor="basic_checkbox_1">Remember my
                                preference</label>
                        </div>
                    </div>
                    <div className="form-group ms-2">
                        <Link
                            to={ROUTES.FORGOTPWD}
                            className="text-white"
                        >
                            Forgot Password?
                        </Link>
                    </div>
                </div>

                <div className="text-center">
                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={submitting}
                    >
                        {submitting ? (
                            <>
                                <i className="spinner-border spinner-border-sm me-1"></i>
                                LOGIN
                            </>
                        ) : (
                            <>
                                LOGIN
                                <i className="fa fa-sign-in ms-1"></i>
                            </>
                        )}
                    </button>
                </div>



            </form>
        </div>
    )
}

export default Login
